/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {AddQualityGradingModelAssignment} from '../bioplanModels';
// @ts-ignore
import type {QualityGradingModelAssignment} from '../bioplanModels';
/**
 * QualityGradingModelAssignmentApi - axios parameter creator
 * @export
 */
export const QualityGradingModelAssignmentApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @param {string} assignmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    qualityGradingModelAssignmentsAssignmentIdDelete: async (
      assignmentId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'assignmentId' is not null or undefined
      assertParamExists('qualityGradingModelAssignmentsAssignmentIdDelete', 'assignmentId', assignmentId);
      const localVarPath = `/qualityGradingModelAssignments/{assignmentId}`.replace(
        `{${'assignmentId'}}`,
        encodeURIComponent(String(assignmentId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} assignmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    qualityGradingModelAssignmentsAssignmentIdGet: async (
      assignmentId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'assignmentId' is not null or undefined
      assertParamExists('qualityGradingModelAssignmentsAssignmentIdGet', 'assignmentId', assignmentId);
      const localVarPath = `/qualityGradingModelAssignments/{assignmentId}`.replace(
        `{${'assignmentId'}}`,
        encodeURIComponent(String(assignmentId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} assignmentId
     * @param {QualityGradingModelAssignment} qualityGradingModelAssignment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    qualityGradingModelAssignmentsAssignmentIdPut: async (
      assignmentId: string,
      qualityGradingModelAssignment: QualityGradingModelAssignment,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'assignmentId' is not null or undefined
      assertParamExists('qualityGradingModelAssignmentsAssignmentIdPut', 'assignmentId', assignmentId);
      // verify required parameter 'qualityGradingModelAssignment' is not null or undefined
      assertParamExists(
        'qualityGradingModelAssignmentsAssignmentIdPut',
        'qualityGradingModelAssignment',
        qualityGradingModelAssignment,
      );
      const localVarPath = `/qualityGradingModelAssignments/{assignmentId}`.replace(
        `{${'assignmentId'}}`,
        encodeURIComponent(String(assignmentId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        qualityGradingModelAssignment,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    qualityGradingModelAssignmentsGet: async (
      planId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('qualityGradingModelAssignmentsGet', 'planId', planId);
      const localVarPath = `/qualityGradingModelAssignments/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (planId !== undefined) {
        localVarQueryParameter['planId'] = planId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @param {AddQualityGradingModelAssignment} addQualityGradingModelAssignment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    qualityGradingModelAssignmentsPost: async (
      addQualityGradingModelAssignment: AddQualityGradingModelAssignment,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'addQualityGradingModelAssignment' is not null or undefined
      assertParamExists(
        'qualityGradingModelAssignmentsPost',
        'addQualityGradingModelAssignment',
        addQualityGradingModelAssignment,
      );
      const localVarPath = `/qualityGradingModelAssignments/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(
        addQualityGradingModelAssignment,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * QualityGradingModelAssignmentApi - functional programming interface
 * @export
 */
export const QualityGradingModelAssignmentApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = QualityGradingModelAssignmentApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} assignmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async qualityGradingModelAssignmentsAssignmentIdDelete(
      assignmentId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.qualityGradingModelAssignmentsAssignmentIdDelete(
        assignmentId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['QualityGradingModelAssignmentApi.qualityGradingModelAssignmentsAssignmentIdDelete']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} assignmentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async qualityGradingModelAssignmentsAssignmentIdGet(
      assignmentId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QualityGradingModelAssignment>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.qualityGradingModelAssignmentsAssignmentIdGet(
        assignmentId,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['QualityGradingModelAssignmentApi.qualityGradingModelAssignmentsAssignmentIdGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} assignmentId
     * @param {QualityGradingModelAssignment} qualityGradingModelAssignment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async qualityGradingModelAssignmentsAssignmentIdPut(
      assignmentId: string,
      qualityGradingModelAssignment: QualityGradingModelAssignment,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QualityGradingModelAssignment>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.qualityGradingModelAssignmentsAssignmentIdPut(
        assignmentId,
        qualityGradingModelAssignment,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['QualityGradingModelAssignmentApi.qualityGradingModelAssignmentsAssignmentIdPut']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {string} planId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async qualityGradingModelAssignmentsGet(
      planId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QualityGradingModelAssignment>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.qualityGradingModelAssignmentsGet(planId, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['QualityGradingModelAssignmentApi.qualityGradingModelAssignmentsGet']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @param {AddQualityGradingModelAssignment} addQualityGradingModelAssignment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async qualityGradingModelAssignmentsPost(
      addQualityGradingModelAssignment: AddQualityGradingModelAssignment,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QualityGradingModelAssignment>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.qualityGradingModelAssignmentsPost(
        addQualityGradingModelAssignment,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['QualityGradingModelAssignmentApi.qualityGradingModelAssignmentsPost']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * QualityGradingModelAssignmentApi - factory interface
 * @export
 */
export const QualityGradingModelAssignmentApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = QualityGradingModelAssignmentApiFp(configuration);
  return {
    /**
     *
     * @param {QualityGradingModelAssignmentApiQualityGradingModelAssignmentsAssignmentIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    qualityGradingModelAssignmentsAssignmentIdDelete(
      requestParameters: QualityGradingModelAssignmentApiQualityGradingModelAssignmentsAssignmentIdDeleteRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .qualityGradingModelAssignmentsAssignmentIdDelete(requestParameters.assignmentId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {QualityGradingModelAssignmentApiQualityGradingModelAssignmentsAssignmentIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    qualityGradingModelAssignmentsAssignmentIdGet(
      requestParameters: QualityGradingModelAssignmentApiQualityGradingModelAssignmentsAssignmentIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<QualityGradingModelAssignment> {
      return localVarFp
        .qualityGradingModelAssignmentsAssignmentIdGet(requestParameters.assignmentId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {QualityGradingModelAssignmentApiQualityGradingModelAssignmentsAssignmentIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    qualityGradingModelAssignmentsAssignmentIdPut(
      requestParameters: QualityGradingModelAssignmentApiQualityGradingModelAssignmentsAssignmentIdPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<QualityGradingModelAssignment> {
      return localVarFp
        .qualityGradingModelAssignmentsAssignmentIdPut(
          requestParameters.assignmentId,
          requestParameters.qualityGradingModelAssignment,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {QualityGradingModelAssignmentApiQualityGradingModelAssignmentsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    qualityGradingModelAssignmentsGet(
      requestParameters: QualityGradingModelAssignmentApiQualityGradingModelAssignmentsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<QualityGradingModelAssignment>> {
      return localVarFp
        .qualityGradingModelAssignmentsGet(requestParameters.planId, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @param {QualityGradingModelAssignmentApiQualityGradingModelAssignmentsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    qualityGradingModelAssignmentsPost(
      requestParameters: QualityGradingModelAssignmentApiQualityGradingModelAssignmentsPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<QualityGradingModelAssignment> {
      return localVarFp
        .qualityGradingModelAssignmentsPost(requestParameters.addQualityGradingModelAssignment, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for qualityGradingModelAssignmentsAssignmentIdDelete operation in QualityGradingModelAssignmentApi.
 * @export
 * @interface QualityGradingModelAssignmentApiQualityGradingModelAssignmentsAssignmentIdDeleteRequest
 */
export interface QualityGradingModelAssignmentApiQualityGradingModelAssignmentsAssignmentIdDeleteRequest {
  /**
   *
   * @type {string}
   * @memberof QualityGradingModelAssignmentApiQualityGradingModelAssignmentsAssignmentIdDelete
   */
  readonly assignmentId: string;
}

/**
 * Request parameters for qualityGradingModelAssignmentsAssignmentIdGet operation in QualityGradingModelAssignmentApi.
 * @export
 * @interface QualityGradingModelAssignmentApiQualityGradingModelAssignmentsAssignmentIdGetRequest
 */
export interface QualityGradingModelAssignmentApiQualityGradingModelAssignmentsAssignmentIdGetRequest {
  /**
   *
   * @type {string}
   * @memberof QualityGradingModelAssignmentApiQualityGradingModelAssignmentsAssignmentIdGet
   */
  readonly assignmentId: string;
}

/**
 * Request parameters for qualityGradingModelAssignmentsAssignmentIdPut operation in QualityGradingModelAssignmentApi.
 * @export
 * @interface QualityGradingModelAssignmentApiQualityGradingModelAssignmentsAssignmentIdPutRequest
 */
export interface QualityGradingModelAssignmentApiQualityGradingModelAssignmentsAssignmentIdPutRequest {
  /**
   *
   * @type {string}
   * @memberof QualityGradingModelAssignmentApiQualityGradingModelAssignmentsAssignmentIdPut
   */
  readonly assignmentId: string;

  /**
   *
   * @type {QualityGradingModelAssignment}
   * @memberof QualityGradingModelAssignmentApiQualityGradingModelAssignmentsAssignmentIdPut
   */
  readonly qualityGradingModelAssignment: QualityGradingModelAssignment;
}

/**
 * Request parameters for qualityGradingModelAssignmentsGet operation in QualityGradingModelAssignmentApi.
 * @export
 * @interface QualityGradingModelAssignmentApiQualityGradingModelAssignmentsGetRequest
 */
export interface QualityGradingModelAssignmentApiQualityGradingModelAssignmentsGetRequest {
  /**
   *
   * @type {string}
   * @memberof QualityGradingModelAssignmentApiQualityGradingModelAssignmentsGet
   */
  readonly planId: string;
}

/**
 * Request parameters for qualityGradingModelAssignmentsPost operation in QualityGradingModelAssignmentApi.
 * @export
 * @interface QualityGradingModelAssignmentApiQualityGradingModelAssignmentsPostRequest
 */
export interface QualityGradingModelAssignmentApiQualityGradingModelAssignmentsPostRequest {
  /**
   *
   * @type {AddQualityGradingModelAssignment}
   * @memberof QualityGradingModelAssignmentApiQualityGradingModelAssignmentsPost
   */
  readonly addQualityGradingModelAssignment: AddQualityGradingModelAssignment;
}

/**
 * QualityGradingModelAssignmentApi - object-oriented interface
 * @export
 * @class QualityGradingModelAssignmentApi
 * @extends {BaseAPI}
 */
export class QualityGradingModelAssignmentApi extends BaseAPI {
  /**
   *
   * @param {QualityGradingModelAssignmentApiQualityGradingModelAssignmentsAssignmentIdDeleteRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QualityGradingModelAssignmentApi
   */
  public qualityGradingModelAssignmentsAssignmentIdDelete(
    requestParameters: QualityGradingModelAssignmentApiQualityGradingModelAssignmentsAssignmentIdDeleteRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return QualityGradingModelAssignmentApiFp(this.configuration)
      .qualityGradingModelAssignmentsAssignmentIdDelete(requestParameters.assignmentId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {QualityGradingModelAssignmentApiQualityGradingModelAssignmentsAssignmentIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QualityGradingModelAssignmentApi
   */
  public qualityGradingModelAssignmentsAssignmentIdGet(
    requestParameters: QualityGradingModelAssignmentApiQualityGradingModelAssignmentsAssignmentIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return QualityGradingModelAssignmentApiFp(this.configuration)
      .qualityGradingModelAssignmentsAssignmentIdGet(requestParameters.assignmentId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {QualityGradingModelAssignmentApiQualityGradingModelAssignmentsAssignmentIdPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QualityGradingModelAssignmentApi
   */
  public qualityGradingModelAssignmentsAssignmentIdPut(
    requestParameters: QualityGradingModelAssignmentApiQualityGradingModelAssignmentsAssignmentIdPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return QualityGradingModelAssignmentApiFp(this.configuration)
      .qualityGradingModelAssignmentsAssignmentIdPut(
        requestParameters.assignmentId,
        requestParameters.qualityGradingModelAssignment,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {QualityGradingModelAssignmentApiQualityGradingModelAssignmentsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QualityGradingModelAssignmentApi
   */
  public qualityGradingModelAssignmentsGet(
    requestParameters: QualityGradingModelAssignmentApiQualityGradingModelAssignmentsGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return QualityGradingModelAssignmentApiFp(this.configuration)
      .qualityGradingModelAssignmentsGet(requestParameters.planId, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @param {QualityGradingModelAssignmentApiQualityGradingModelAssignmentsPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof QualityGradingModelAssignmentApi
   */
  public qualityGradingModelAssignmentsPost(
    requestParameters: QualityGradingModelAssignmentApiQualityGradingModelAssignmentsPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return QualityGradingModelAssignmentApiFp(this.configuration)
      .qualityGradingModelAssignmentsPost(requestParameters.addQualityGradingModelAssignment, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
